import React from 'react';
import { Heading, Section } from '@carbon/react';
import PageContainer from '../components/PageContainer';

const Help = () => {
  return (
    <PageContainer>
      <Section>
        <Heading style={{ marginBottom: '2rem' }}>Pomoć</Heading>
        <p style={{ maxWidth: '600px', lineHeight: '1.6' }}>
          Dobrodošli u centar za pomoć. Ovde ćete uskoro pronaći uputstva i
          odgovore na najčešća pitanja o korišćenju aplikacije.
        </p>
      </Section>
    </PageContainer>
  );
};

export default Help;
